import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Login, LoginResponse } from '../classes/login';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthService implements CanActivate {

  private hostName;

  private authEmitter;

  constructor(private http: HttpClient, private router: Router) {
    this.hostName = environment.apiHost;
  }

  login(loginModel: Login): Observable<LoginResponse> {
    return this.http.post(this.hostName + '/api/account/login', loginModel)
      .pipe(map((res: LoginResponse) => {

        if(res.success)
        {
           this.saveLoggedInStatus(true);
           this.authEmitter.next(true);
           return res;
        }

        return res;

      }))
      .pipe(catchError(e => {

        // Unable to reach backend or HTTP response error, such as a 500

        const invalidResponse: LoginResponse = {
          success: false,
          error: "Unknown error authenticating"
        };

        return of(invalidResponse);
      }));
  }

  logout(notifyBackend: boolean = true) {

    this.saveLoggedInStatus(false);
    this.authEmitter.next(false);

    // Ping the backend and tell it to destroy the session
    if(notifyBackend)
    {
      return this.http.post(this.hostName + '/api/account/Logout', null)
            .pipe(map(() => {
              return of(true);
            })).pipe(catchError(e => {
              return of(false);
            }));
    }
    
  }

  isLoggedIn(): boolean {
    return localStorage.getItem('isLoggedIn') === null ? false : true;
  }

  authEvent(): Observable<boolean> {
    return Observable.create(e => this.authEmitter = e);
  }

  canActivate(): boolean {

    if (this.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login'])
    }
  }

  private saveLoggedInStatus(isLoggedIn: boolean)
  {
    if(isLoggedIn){
      localStorage.setItem('isLoggedIn', '1');
    }
    else{
      localStorage.removeItem('isLoggedIn');
    }
  }
  
}
